import React from 'react';
import styled from 'styled-components';
import Textarea from 'react-textarea-autosize';
import ColorConstants from '../../../constants/ColorConstants';
import { MobileScreen } from '../../styles/ConstantMediaQuery';
import isMobile from '../../../utils/isMobile';
import ScrollbarStyle from '../../styles/ConstScrollbarStyle';
import TEST_IDS from '../../../utils/_tests/testIds.constants';


const defaultProps = {
    value: '',
    id: 'titleTextArea',
    maxLength: 200,
    maxRows: isMobile ? 4 : 6,
    placeholder: '',
    readOnly: false,
    onChange: () => {},
};

const ModalTitle = ({ value, ...props }) => (
    <Title
        data-testid={TEST_IDS.MODAL.MODAL_TITLE}
        defaultValue={value}
        {...props}
    />
);

const Title = styled(Textarea)`
    background-color: transparent;
    border-radius: 4px;
    border: 1px solid transparent;
    box-sizing: border-box;
    color: ${ColorConstants.white};
    font-family: Helvetica;
    font-size: 24px;
    font-weight: bold;
    margin: 25px 0 25px;
    padding: 5px;
    resize: none;
    text-align: center;
    transition: all 0.1s;
    width: 550px;

    &:focus {
        border-color: ${ColorConstants.white};
    }

    ::placeholder {
        color: ${ColorConstants['white-50%']};
    }

    :-ms-input-placeholder {
        color: ${ColorConstants['white-50%']};
    }

    ::-ms-input-placeholder {
        color: ${ColorConstants['white-50%']};
    }

    ${ScrollbarStyle};

    @media ${MobileScreen} {
        width: calc(100vw - 20px);
    }
`;

ModalTitle.defaultProps = defaultProps;

export default ModalTitle;
